// extracted by mini-css-extract-plugin
export var container = "_dy-0";
export var popoverContent = "_dy-1";
export var tosLink = "_dy-2";